var _excluded = ["customStyle", "disabled", "display", "filled", "focusable", "size", "label"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { useTheme } from '@veneer/theme';
import CustomImage from '../custom_image';
import propTypes from './prop_types';
import ICON_PLACEHOLDER_PATH from '../../assets/icon_placeholder_path';
import useDirection from '../direction/use_direction';
import { jsx as ___EmotionJSX } from "@emotion/core";
var makeIcon = (name, defaultLabel, flippable, _ref, warnings) => {
  var {
    roundFilled = ICON_PLACEHOLDER_PATH,
    roundLined = ICON_PLACEHOLDER_PATH,
    sharpFilled = ICON_PLACEHOLDER_PATH,
    sharpLined = ICON_PLACEHOLDER_PATH,
    roundFilledRtl = roundFilled,
    roundLinedRtl = roundLined,
    sharpFilledRtl = sharpFilled,
    sharpLinedRtl = sharpLined
  } = _ref;
  var warned = false;
  var Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
    var {
        customStyle,
        disabled = false,
        display = 'inline-block',
        filled,
        focusable = false,
        size = 24,
        label = defaultLabel
      } = _ref2,
      other = _objectWithoutPropertiesLoose(_ref2, _excluded);
    var theme = useTheme();
    var {
      isRTL
    } = useDirection();
    if (process.env.NODE_ENV === 'development' && warnings !== null && warnings !== void 0 && warnings.removed && !warned) {
      console.warn("@veneer/core: The ".concat(name, " component has been deprecated and it'll be removed in the next major release."));
      warned = true;
    }
    if (process.env.NODE_ENV === 'development' && warnings !== null && warnings !== void 0 && warnings.deprecated && !warned) {
      console.warn(["@veneer/core: The ".concat(name, " component has been deprecated and it'll be removed in the next major release."), "Use ".concat(warnings.deprecated, " instead.")].join(' '));
      warned = true;
    }
    var iconStyle = _extends({
      display
    }, disabled && {
      color: theme.palette.foreground.disabled
    }, customStyle);
    var pathData = theme.shape === 'sharp' ? filled ? isRTL ? sharpFilledRtl : sharpFilled : isRTL ? sharpLinedRtl : sharpLined : filled ? isRTL ? roundFilledRtl : roundFilled : isRTL ? roundLinedRtl : roundLined;
    return ___EmotionJSX(CustomImage, _extends({
      customStyle: iconStyle,
      disabled: disabled,
      ref: ref,
      title: label || undefined,
      focusable: focusable,
      size: size,
      flippable: flippable
    }, other), ___EmotionJSX("path", {
      d: pathData
    }));
  });
  Icon.propTypes = propTypes;

  // @ts-expect-error todo: a neater way of doing this
  Icon.isVeneerIcon = true;
  Icon.displayName = name;
  return Icon;
};
export default makeIcon;